<template>
  <div v-loading="loading" ref="scroller" class="impersonate-users pr-2 h-full">
    <div class="flex justify-between items-center mb-2">
      <h2 class="font-bold text-18px">Impersonate user</h2>
      <button class="campaign-type-modal__close text-base" @click="close"><i class="icon-Close font-bold"></i></button>
    </div>
    <el-scrollbar class="flex-grow" :style="{ height: scrollerHeight }">
      <div v-for="(item, index) in accounts" :key="index" class="divide-y divide-grayNeutralLight">
        <template v-if="item.accounts.length > 0">
          <div class="font-bold text-14px mb-2">{{ item.name }}</div>

          <ul role="list">
            <li v-for="user in item.accounts" :key="user.id" class="flex justify-between gap-x-6 py-1">
              <div class="flex min-w-0 gap-x-2">
                <img class="size-12 flex-none rounded-full bg-gray-50 w-4 h-4" :src="user?.user_settings?.company_logo" alt="" />
                <div class="min-w-0 flex-auto">
                  <p class="text-sm/6 font-semibold text-gray-900 mb-0">{{ user.name }}</p>
                  <p class="truncate text-xs/5 text-gray-500">{{ user.email }}</p>
                </div>
              </div>
              <div class="hidden shrink-0 sm:flex sm:flex-col sm:items-end mr-4">
                <a :href="`/impersonate/${user.id}?redirect=${redirect}`" class="el-button el-button--default is-circle">
                  <i class="el-icon-connection"></i>
                </a>
              </div>
            </li>
          </ul>
        </template>
      </div>
    </el-scrollbar>
  </div>
</template>
<script>
export default {
  props: {
    meta: {
      type: null,
    },
  },
  data() {
    return {
      loading: false,
      accounts: [],
      scrollerHeight: '100%',
    }
  },
  created() {
    this.init()
  },
  mounted() {
    this.scrollerHeight = this.$refs.scroller.offsetHeight - 80 + 'px'
  },
  computed: {
    redirect() {
      return this.$route.path
    },
  },
  methods: {
    close() {
      this.$Drawer.instance.isOpen = false
    },
    async init() {
      this.loading = true
      try {
        const { data } = await this.axios.get(`/api/social-products/social-boost/accounts/${this.meta.campaign.id}`)

        const { agency, 'agency-employee': agencyEmployee, 'brand-admin': brandAdmin, 'brand-employee': brandEmployee } = data || {}

        this.accounts = [
          {
            name: 'Agency Admin',
            accounts: agency || [],
          },
          {
            name: 'Agency Employee',
            accounts: agencyEmployee || [],
          },
          {
            name: 'Brand Admin',
            accounts: brandAdmin || [],
          },
          {
            name: 'Brand Employee',
            accounts: brandEmployee || [],
          },
        ]
      } catch (error) {
        console.error('Error fetching accounts:', error)
        this.accounts = []
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
<style lang="scss">
.impersonate-users {
  .el-scrollbar__wrap {
    @apply overflow-x-hidden;
  }
}
</style>
